import React, { Component } from 'react';
import { Route, Router, withRouter, Switch, Redirect } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/css/index.css';
import { Dashboard } from './views';
import auth from './auth/auth.js';
import { Main as MainLayout } from './layouts';
import PrivateRoute from './auth/privateRoute.js';
import Callback from './auth/callback.js';
import { getDynamicConfigValue } from './dynamicConfig';
import { fetchBrandingInfo } from "./graphql/getBrandingInfo";

const browserHistory = createBrowserHistory();

class App extends Component {
  state = {
    brandingInfo: {}
  };

  async getBrandingInfo() {
    var brandingInfo = {};
    if (localStorage.getItem("id_token")) {
      brandingInfo = await fetchBrandingInfo();
    } 
    this.setState({
      brandingInfo: brandingInfo
    })
  }

  async componentDidMount() {
    if (getDynamicConfigValue('REACT_APP_AUTH_METHOD') === "auth0") { // Perform authentication flow only if set to auth0 in .env
      //console.log('this.props.location.pathname: ', this.props.location.pathname)
      if (this.props.location.pathname === "/callback") {
        return;
      }
      //console.log('past callback')    
      try {
        localStorage.setItem("path", this.props.location.pathname);
        if(this.props.location.pathname.includes("AML-Dashboard") || this.props.location.pathname === "/") {
          localStorage.setItem('Aml', true);
          localStorage.setItem('Fraud', false);
        } else if(this.props.location.pathname.includes("Fraud-Dashboard")) {
          localStorage.setItem('Aml', false);
          localStorage.setItem('Fraud', true);
        }
        //console.log('auth.silentAuth()')          
        await auth.silentAuth();
        if (getDynamicConfigValue('REACT_APP_RUN_MODE') === 'partner') {
          await this.getBrandingInfo();
        }
        // console.log('this.forceUpdate')
        this.forceUpdate();
      } catch (err) {
        if (err.message === "login_required" || err.error === "login_required") {
          auth.login();
        } else {
          alert('An unknown error occurred, check the console for details.');
          console.log('authentication error: ', err);
        }
        return;
      }
    }
  }
  render() {
    //console.log(localStorage.getItem('Fraud'));
    // const getPage =
    //   localStorage.getItem('Fraud') !== null
    //   ? localStorage.getItem('Fraud') === 'true' &&
    //   localStorage.getItem('Aml') === 'false'
    //   ? '/solution/Fraud-Dashboard'
    //   : '/solution/AML-Dashboard'
    //   : '/solution/AML-Dashboard';
    // const getPage = '/solution/AML-Dashboard';
    const { brandingInfo } = this.state;
    return (
      <ThemeProvider theme={theme}>
        <Router history={browserHistory}>
          <Switch>
            <Redirect exact from="/" to="/solution/AML-Dashboard" />
            <Route exact path="/callback" component={Callback} />
            <PrivateRoute
              component={Dashboard}
              exact
              path="/solution/:id"
              layout={MainLayout}
              brandingInfo={brandingInfo}
            />
          </Switch>
        </Router>
      </ThemeProvider>
    );
  }
}

export default withRouter(App);
